import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        props: (route) => ({ client: route.params.client || route.query.client })
    },
    {
        path: '/about',
        name: 'about',
        component: AboutView
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/getConfig',
        redirect: (to) => {
            // const client = to.query.client
            const client = to.query.id
            // console.log(client)
            return { name: 'home', params: { client: client } }
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
